import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupBaramundiGroup } from "./baramundi";

const BaramundiSetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const BaramundiSetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Fresh section per catalog build - see network/section.ts for the rationale.
export const baramundiScanners = (): Section => {
  const baramundiScanners = new Section("baramundi_scanner", [
    new Translation("en", "Baramundi Scanners"),
    new Translation("de", "Baramundi-Scanner"),
  ]);
  baramundiScanners.help = [
    new Translation(
      "en",
      `Add Baramundi to get more detailed information about their API!`
    ),
    new Translation(
      "de",
      `Fügen Sie Baramundi hinzu, um detailliertere Informationen über deren API zu erhalten!`
    ),
  ];

  baramundiScanners.description = [
    new Translation("en", BaramundiSetupEn),
    new Translation("de", BaramundiSetupDe),
  ];

  setupBaramundiGroup(baramundiScanners, 0);
  return baramundiScanners;
};
